<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3">
            <v-icon class="me-2" color="secondary" size="20">icon-piechart</v-icon>{{$auth.user.employee ? 'درجه اهمیت تیکت‌های مشتریان' : 'درجه اهمیت تیکت‌ها'}}
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "radialBar"
                },
                plotOptions: {
                    radialBar: {
                        startAngle: 0,
                        endAngle: 270,
                        hollow: {
                            margin: 5,
                            size: "30%",
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                show: false,
                            },
                        },
                        barLabels: {
                            enabled: true,
                            useSeriesColors: true,
                            fontFamily: "iransans",
                            offsetX: -8,
                            fontSize: '12px',
                            formatter: function (seriesName, opts) {
                                return ( seriesName + ":  " + "%" + opts.w.globals.series[opts.seriesIndex] );
                            },
                        },
                    },
                },
                colors: ["#34c38f", "#ffdc2b", "#ffa62b", "#db3a31"],
                labels: [],
            },
            search: [],
        };
    },
    methods: {
        reportImportanceTicketFilter(search) {
            this.skeleton = true;
            this.search = {...search};
            this.reportImportanceTicketGet();
        },
        reportImportanceTicketGet() {
            this.$reportImportanceTicket(this.search).then((res) => {
                if (res && res.status == "OK") {
                    this.series = [];
                    this.chartOptions.labels = [];
                    let total = res.data.reduce((total, num) => {
                        return total + Number(num.total);
                    }, 0);
                    total = total == 0 ? 1 : total;
                    this.series.push( ...res.data.map((item) => parseInt((item.total / total) * 100) ) );
                    this.chartOptions.labels.push( ...res.data.map((item) => this.$system.importances.find(x => x.id == item.x).name) );
                    this.skeleton = false;
                }
            });
        },
    },
    mounted() {
        this.reportImportanceTicketGet();
    },
};
</script>
